import { useState, createContext } from "react"


export const AppContext = createContext<{
  setLanguage: (language: string) => void,
  Lang: any,
} | null>(null)

export const AppProvider = ({ children }) => {

  const [language, setLanguage] = useState('Chinese')

  const chooseLanguage = (info) => {
    if (language === 'English') return info.English
    return info.Chinese
  }

  const Text = {
    English: {
      'lptoken': '如果您的代币有持仓分红机制，并且已开盘，请开启此项!',
      "SOLBot": "SOL Volume Bot",
      "Advanced": "Advanced Settings",
      "SelectChain": "Chain",
      "SelectRouter": "Router",
      "RPC": "RPC",
      "FeeTier": "Pool Fee Tier",
      "Batchtools": "Batch Tools",
      "Createwallets": "Create Wallets",
      "Sendtokens": "Token Batch Transfer",
      "Batchcollection": "Batch Collection",
      "Marketmanagement": "Volume Bot",
      "nodelist": "Node List",
      "Frontrobot": "Sniper Bot",
      "Howtousewallet": "Wallet Usage",
      "Order": "Order",
      "random": "Random",
      "Usethewalletinorder": "Use the wallet in order",
      "Randomuseofwallets": "Random use of wallets",
      "Mode": "Mode",
      "pullplate": "Buy",
      "Smashtheplate": "Sell",
      "Brushingtradingvolume": "Volume Boost",
      "Sellhighbuylow": "Buy Low, Sell High",
      "t1": "For example, select USDT as the token to spend, fill in 100~100 as the selling amount, and get 100 USDT after selling the tokens in the wallet.",
      "t2": "Fill in 100~100 for the selling quantity, and 100 tokens will be collected in the selling wallet.",
      "t3": "Fill in 50~50 for the selling percentage, and sell 50% of the number of tokens in the wallet",
      "contractAddress": "Contract Address",
      "poolType": "Pool Type",
      "spenToken": "Spen Token",
      "currentprice": "Current Price",
      "targetPrice": "Target Price",
      "Buyprobability": "Buy Probability",
      "Buycalculationmethod": "Buy Strategy",
      "Amount": "Amount",
      "Quantity": "Quantity",
      "t4": "Use your wallet to buy tokens and increase token prices",
      "t5": "Use your wallet to sell tokens and lower the token price",
      "t6": "Volume Boost",
      "t7": "Sell high, buy low, and set the price to a certain range",
      "t8": "For example, if you choose USDT to spend tokens and fill in 100~100 for the purchase amount, you will use 100 USDT to buy tokens each time.",
      "t9": "Fill in 100~100 for the purchase quantity, which means buying 100 tokens for each transaction, which is suitable for buying restricted tokens.",
      "t10": "Buying amount (take a random number between two numbers)",
      "t11": "Buying quantity (take a random number between two numbers)",
      "t12": "Sell Strategy",
      "percentage": "Percentage",
      "t13": "Selling amount",
      "t14": "Sell Quantity",
      "t15": "Sell Percentage",
      "t16": "Time Interval",
      "t17": "The options below (optional, don’t fill in if not required)",
      "t18": "Trade Count",
      "minprice": "Min Price",
      "buylow": "buy low",
      "maxPrice": "Max Price",
      "highthrow": "high throw",
      "t19": "Multi-Wallet Trading",
      "t20": "Execution Count",
      "startTime": "Start Time",
      "t21": "Automatic currency transfer",
      "t22": "Amount of BNB transferred at a time",
      "buyTokenWeight": "Probability value, between 0-100. For example: 10, then there is a 10% probability of executing a buy order and a 90% probability of executing a sell order. 70, then there is a 70% probability of executing a buy order and a 30% probability of executing a sell order.",
      "maxBuyTokenAmount": "The maximum limit on the cumulative amount of currency purchased. Example: ALPACA--USDT, set to 100. ALPACA can be purchased an unlimited number of times. When the cumulative number of purchases reaches 100, the module will stop executing.",
      "maxSellTokenAmount": "The maximum limit on the cumulative amount of currency sold. Example: ALPACA--USDT, set to 100. ALPACA can be sold an unlimited number of times. When the cumulative number of sales reaches 100, the module will stop executing.",
      "minTokenPrice": "Expected lowest price < real-time price < expected highest price Example: ALPACA--USDT, real-time price: 1 ALPACA =0.402133 USDT, lowestPrice < 0.402133 USDT, highest price > 0.402133 USDT.",
      "minTradeAmount": "Sell amount: For example, fill in 10, 10, and select USDT for the tokens spent. Then you will get 10 USDT each time you perform a sell operation. Sell quantity: For example, fill in 10, 10, and 10 tokens will be sold when you perform a sell operation. Selling percentage: For example, fill in 10,10, and executing the selling operation will sell 10% of the total number of tokens in the wallet.",
      "minTime": "The time between two task executions. For example: set to 5~20 seconds, the next task execution interval of the system will be within 5~20 seconds.",
      "targetPrice_": "Stop the program when the target price is reached.",
      "useWalletWay": "Random: use the wallet randomly, Order: use the wallet in order",
      "gasPrice": "gasPrice",
      "gasLimit": 'gasLimit, If your token is more complex, please increase the gasLimit',
      "pairContract": 'For example, if you add a USDT pool, the pool type is USDT, and if you add a BNB pool, the pool type is WBNB.',
      "spenAddress": 'Select WBNB, use BNB in the wallet when buying tokens, and get BNB when selling tokens. Select USDT, use USDT when buying tokens, and get USDT when selling tokens.',
      "spenType": "For example, the token spent is USDT, and the purchase amount is filled in 100, 100. If you select the amount as the calculation method, you will spend 100 USDT to buy the token. If you select the quantity, you will get 100 tokens, and the USDT you need to spend will be automatically calculated. The contract has a limited purchase function, please select the quantity to operate",
      "buyAmount": 'Buy-in amount: Each transaction costs a random number between two numbers. Buy-in amount: Get a random number of tokens between two numbers.',
      "tradeNumber": 'For example, if you fill in 6, the total number of purchases + the number of sales = 6, the program will stop. Default is infinity',
      "minPeice": 'During the execution process, if the current price is lower than the lowest price, execution will stop. The default is 0.',
      "maxPrice_": 'During the execution process, if the current price is higher than the highest price, execution will stop and the default is infinity.',
      "highthrow_": `Start selling above a certain price, used for market value management maximum price limit`,
      "buylow_": `Start attracting purchases below a certain price, which is used for market value management and price support.`,
      "autoTransFer": `For example: When using USDT pulling, when a brush wallet is randomly selected for buying operations, you need to ensure that there is a sufficient amount of USDT in the wallet. If the amount of USDT is insufficient, it will automatically be transferred from the loaded wallet to the amount set here. Amount of USDT`,
      "autoTransFerGas": `When a brush wallet is randomly selected for buying and selling operations, it is necessary to ensure that there is a sufficient amount of BNB in the wallet as gas fee. If the fee is insufficient, the amount set here will be automatically transferred from the loaded wallet. BNB`,
      "isBatch": `Multiple wallets buy or sell at the same time (the buying calculation method must select the amount, and the selling calculation method must select the quantity or percentage)`,
      "batchNumber": 'For example, if the execution quantity is entered as 2, all wallets will execute the transaction twice.',
      "refresh": "Refresh",
      "Totalwallets": "Total Wallets",
      "Total": "Total",
      "Token": "Token",
      "WalletAddress": "Wallet Address",
      "balance": "Balance",
      "Nodeupdatedsuccessfully": "Node updated successfully",
      "q1": "Please fill in the contract address",
      "q2": "Please fill in the pool address",
      "q3": "Please fill in the spending token address",
      "q4": "Please fill in the target price",
      "q5": "Please fill in the buy",
      "q6": "Please fill in sell",
      "q7": "Please fill in the buying probability",
      "q8": "Please fill in the time interval",
      "q9": "Please fill in the number of batch transaction executions",
      "q10": "Please fill in the start time",
      "q11": "Please fill in the single transfer quantity",
      "q12": "Please fill in the lowest price",
      "q13": "Please fill in the highest price",
      "q14": "The price is no longer in the sell-high, buy-low range",
      "q15": "The current wallet is not a member",
      "q16": "Please connect wallet",
      "q17": "The current price was not obtained, please switch network nodes.",
      "q18": "Pull task completed",
      "q19": "The task of smashing the disk is completed",
      "q20": "The number of times of brushing transaction volume is completed",
      "q21": "If the current price is less than the lowest price, the task is completed and continue to monitor price changes.",
      "q22": "If the current price is greater than the highest price, the task is completed and continue to monitor price changes.",
      "q23": "Authorization swap successful",
      "q24": "Authorization swap failed",
      "q25": "Authorize gas",
      "wait": "wait",
      "Second": "Second",
      "No": "No.",
      "q26": "Executions-Buy Order-Wallet",
      "q27": "will get",
      "q28": "will use",
      "q29": "Paying orders costs gas",
      "q30": "Buy successfully",
      "q31": "Buy failed",
      "q32": "Execution-Sell Order-Wallet",
      "q33": "will sell",
      "wallet": "wallet",
      "TokenTotal": "Token Total",
      "q34": "Tokens will be cleared",
      "q35": "Sell wallet tokens %",
      "q36": "The quantity is",
      "q37": "Spend gas",
      "q38": "Sold successfully",
      "q39": "Selling failed",
      "w1": "Node connection error, switching market value robot network nodes",
      "w2": "Gas is enough",
      "w3": "Start to wallet",
      "transfer": "transfer",
      "w4": "Sufficient balance",
      "transferSueece": "transfer successfully",
      "w5": "If the transfer fails, the next wallet will be used to start execution.",
      "w6": "All wallet balances are insufficient",
      "w7": "The robot stops performing the task",
      "w8": "Node connection error, please switch the market value robot network node",
      "poolAddress": "Pool Address",
      "lowPrice": "price lower than",
      "startLowBuy": "Start buying low",
      "hiegtPrice": "price higher than",
      "startHighSell": "Start selling high",
      "downTime": "Countdown",
      "a1": "Buying authorization (no authorization is required to use BNB to buy, but must be authorized first to use USDT to buy in bulk)",
      "a2": "Selling authorization (batch sales must be authorized first)",
      "a3": "Start executing batch transactions",
      "a4": "Pause",
      "a5": "Clear Log",
      "startBuy": "Start",
      "a6": "Stop",
      "Importprivatekey": "Import the brush wallet private key",
      "close": "close",
      "a7": "One private key per line",
      "import": "import",
      "importwallet": "Import Wallet",
      "a8": "1: Please use a safe browser operation",
      "a9": "2: After each operation is completed, click the Import Brushing Wallet button to delete the private key",
      "a10": "3: The platform will not obtain your private key and is not responsible for any loss of funds.",
      "a11": "Market Value Robot Teaching Video",
      "c1": 'Sec',
      "c2": 'Trading Slippage (If there is a clamp robot, please set the slippage) Slippage ',
      "c3": 'Slippage',
      "c4": "Gas Setting",
      "c5": '(buy and sell with multiple wallets at the same time',
      "c6": "(If you need to execute it on a scheduled basis, please enable this function)",
      "c7": "(If you need to execute it on a scheduled basis, please enable this function)",
      "c8": 'Operation',
      "c9": "Please keep your private key carefully",
      "c10": "Authorization Status",
      "c11": "Sell",
      "c12": "If it is a platform problem, the maximum compensation limit is 3,000 knives, please know",
      "c13": "Must-see for use",
      "c14": "Watch the tutorial video first",
      "c15": "These three are generally not required",
      "c16": "If there is a clip, set slippage",
      "c17": "If the balance cannot be read, or a network error is prompted, switch nodes here",
      "c18": "If all nodes have been switched and it still doesn't work, then it's a VPN problem. Just switch the VPN node"
    },
    Chinese: {
      "FeeTier": "池子费用级别",
      "Advanced": "高级设置",
      "SOLBot": "SOL市值机器人",
      "c18": "如果所有节点都切换过了还不行，那就是VPN的问题，切换下VPN节点即可",
      "c17": "如果余额读取不出来，或者提示网络错误，就在这里切换下节点",
      "c16": "有夹子的话，就设置下滑点",
      "c15": "这三个一般不用开",
      "c14": "先看下教程视频",
      "c13": "使用必看",
      "c12": "如果是平台问题，最大赔付额度为3000刀，请知悉",
      "c11": "卖出",
      "c10": "授权状态",
      "c9": "请保存好你的私钥",
      "c8": '操作',
      "c7": "(如果有定时执行的需求请开启该功能)",
      "c6": "(默认一次，如果需要多次请输入)",
      "c5": '(多钱包同时买入卖出)',
      "c4": 'Gas设置',
      "c3": '滑点',
      "c2": '交易滑点',
      "c1": '秒',
      'lptoken': '如果您的代币有持仓分红机制，并且已开盘，请开启此项!',
      "SelectChain": "公链",
      "SelectRouter": "交易所",
      "RPC": "网络节点",
      "Batchtools": "批量工具",
      "Createwallets": "批量生成钱包",
      "Sendtokens": "批量发送代币",
      "Batchcollection": "批量归集",
      "Marketmanagement": "市值管理",
      "nodelist": "节点列表",
      "Frontrobot": "抢跑机器人",
      "Howtousewallet": "钱包使用方式",
      "Order": "顺序",
      "random": "随机",
      "Usethewalletinorder": "按照顺序使用钱包",
      "Randomuseofwallets": "随机使用钱包",
      "Mode": "模式",
      "pullplate": "拉盘",
      "Smashtheplate": "砸盘",
      "Brushingtradingvolume": "刷交易量",
      "Sellhighbuylow": "高抛低吸",
      "t1": "比如花费的代币选择USDT，卖出金额填写100~100，卖出钱包里的代币得到100USDT",
      "t2": "卖出数量填写100~100，卖出钱包里中100枚代币",
      "t3": "卖出百分比填写50~50，卖出钱包里中50%的代币数量",
      "contractAddress": "代币地址",
      "poolType": "池子类型",
      "spenToken": "花费代币",
      "currentprice": "当前价格",
      "targetPrice": "目标价格",
      "targetPriceMaxAndMin": "目标价格在拉盘时必须大于当前价格，砸盘时必须小于当前价格",
      "Buyprobability": "买入概率",
      "Buycalculationmethod": "买入计算方式",
      "Amount": "金额",
      "Quantity": "数量",
      "t4": "使用钱包买入代币，拉升代币价格",
      "t5": "使用钱包卖出代币，降低代币价格",
      "t6": "刷交易量",
      "t7": "高位卖出，低位买入，将价格规定到一定范围",
      "t8": "比如花费代币选择USDT, 买入金额填写100~100，则是每次使用100USDT去购买代币",
      "t9": "买入数量填写100~100，则是每次交易买入100枚代币，适合买入限购的代币",
      "t10": "买入金额",
      "t11": "买入数量",
      "t12": "卖出计算方式",
      "percentage": "百分比",
      "t13": "卖出金额",
      "t14": "卖出数量",
      "t15": "卖出百分比",
      "t16": "时间间隔",
      "t17": "下面的选项(可选,不需要就不要填写)",
      "t18": "交易次数",
      "minprice": "最低价格",
      "buylow": "低吸",
      "maxPrice": "最高价格",
      "highthrow": "高抛",
      "t19": "钱包同时交易",
      "t20": "执行次数",
      "startTime": "定时开始",
      "t21": "自动转币",
      "t22": "单次转入BNB数量",
      "buyTokenWeight": "概率值，0-100之间。举例：10，则10%概率执行买单，90%概率执行卖单。70，则70%概率执行买单，30%概率执行卖单。",
      "maxBuyTokenAmount": "累计买入币量最大限制 举例：ALPACA--USDT，设置100。ALPACA可无限次数买入，当买入累计达到100，则该模块停止执行",
      "maxSellTokenAmount": "累计卖出币量最大限制 举例：ALPACA--USDT，设置100。ALPACA可无限次数卖出，当卖出累计达到100，则该模块停止执行",
      "minTokenPrice": "预期最低价格 < 实时价格 < 预期最高价格 举例：ALPACA--USDT，实时价格：1 ALPACA =0.402133 USDT，最低价格 < 0.402133 USDT，最高价格 > 0.402133 USDT。",
      "minTradeAmount": "卖出金额：比如填写10，10，底池选择USDT，则每次执行卖出操作将获得10USDT，卖出数量：比如填写10，10，执行卖出操作将卖出10个代币，卖出百分比：比如填写10，10，执行卖出操作将卖出钱包总代币数的10%",
      "minTime": "两次任务执行的间隔时间。举例：设为5~20秒，系统下次执行任务间隔时间在5~20内。",
      "targetPrice_": "达到目标价格时停止程序",
      "useWalletWay": "随机：随机使用钱包，顺序：按照顺序使用钱包",
      "gasPrice": "gasPrice",
      "gasLimit": 'gasLimit, 如果你的代币比较复杂，请加大gasLimit',
      "pairContract": '比如加的是USDT池子，池子类型就是USDT，加的是BNB池子，池子类型就是WBNB',
      "spenAddress": '选择WBNB，买入代币使用钱包里BNB，卖出代币获得bnb,选择USDT，买入代币时使用USDT，卖出代币时获得USDT',
      "spenType": "比如底池是USDT,买入金额都填100，100，计算方式选择金额，则花费100USDT，去购买代币，如果选择数量，则将获得100个代币，自动计算需要花费的USDT，合约有限购功能，请选择数量进行操作",
      "buyAmount": '买入金额：每次交易花费两个数之间的随机数，买入数量：获得两个数之间的随机数量的代币',
      "tradeNumber": '比如填写6，总的买入次数+卖出次数 = 6，程序停止。默认无穷大',
      "minPeice": '在执行过程中，当前价格比最低价格低，停止执行，默认是0',
      "maxPrice_": '在执行过程中，当前价格比最高价格高，停止执行，默认无穷大',
      "highthrow_": `高于某个价格开始抛售，用于市值管理最高价格限制`,
      "buylow_": `低于某个价格开始吸货买入，用于市值管理价格托底`,
      "autoTransFer": `举例:使用USDT拉盘,当随机选中一个刷单钱包进行买入操作时, 需要保证该钱包中有足够数量USDT, 如果USDT数量不足, 将会自动从加载的钱包中转入此处设定的数量的USDT`,
      "autoTransFerGas": `当随机选中一个刷单钱包进行买入卖出操作时, 需要保证该钱包中有足够数量的BNB作为gas费用, 如果费用不足, 将会自动从加载的钱包中转入此处设定的数量的BNB`,
      "isBatch": `多个钱包同时买入或卖出( 买入计算方式必须选择金额，卖出计算方式必须选择数量或百分比)`,
      "batchNumber": '比如执行数量填写2，所有钱包执行两次交易',
      "refresh": "刷新",
      "Totalwallets": "钱包总数",
      "Total": "总量",
      "Token": "代币",
      "WalletAddress": "钱包地址",
      "balance": "余额",
      "Nodeupdatedsuccessfully": "节点更新成功",
      "q1": "请填写合约地址",
      "q2": "请填写池子地址",
      "q3": "请填写花费代币地址",
      "q4": "请填写目标价格",
      "q5": "请填写买入",
      "q6": "请填写卖出",
      "q7": "请填写买入概率",
      "q8": "请填写时间间隔",
      "q9": "请填写批量交易执行次数",
      "q10": "请填写开始时间",
      "q11": "请填写单次转入数量",
      "q12": "请填写最低价格",
      "q13": "请填写最高价格",
      "q14": "价格已不在高抛低吸区间",
      "q15": "当前钱包不是会员",
      "q16": "请连接钱包",
      "q17": "未获取到当前价格，请先查池子",
      "q18": "拉盘任务完成",
      "q19": "砸盘任务完成",
      "q20": "刷交易量次数完成",
      "q21": "当前价格小于最低价格,任务完成,继续监听价格变化",
      "q22": "当前价格大于最高价格,任务完成,继续监听价格变化",
      "q23": "授权swap成功",
      "q24": "授权swap失败",
      "q25": "授权gas",
      "wait": "等待",
      "Second": "秒",
      "No": "第",
      "q26": "次执行-买单-钱包",
      "q27": "将获得",
      "q28": "将使用",
      "q29": "买单花费gas",
      "q30": "买入成功",
      "q31": "买入失败",
      "q32": "次执行-卖单-钱包",
      "q33": "将卖出",
      "wallet": "钱包",
      "TokenTotal": "代币总数量",
      "q34": "将清空代币",
      "q35": "卖出钱包代币百分之",
      "q36": "数量为",
      "q37": "花费gas",
      "q38": "卖出成功",
      "q39": "卖出失败",
      "w1": "节点连接错误，正在切换市值机器人网络节点",
      "w2": "gas充足",
      "w3": "开始向钱包",
      "transfer": "转移",
      "w4": "余额充足",
      "transferSueece": "转移成功",
      "w5": "转移失败,将使用下一个钱包开始执行",
      "w6": "全部钱包余额都不足",
      "w7": "机器人停止执行任务",
      "w8": "节点连接错误，请切换市值机器人网络节点",
      "poolAddress": "池子地址",
      "lowPrice": "价格低于",
      "hiegtPrice": "价格高于",
      "startLowBuy": "开始低吸",
      "startHighSell": "开始高抛",
      "downTime": "倒计时",
      "a1": "买入授权(使用BNB买入不需要授权，使用USDT批量买入必须先授权)",
      "a2": "卖出授权(批量卖出必须先授权)",
      "a3": "开始执行批量交易",
      "a4": "暂停交易",
      "a5": "清空日志",
      "startBuy": "开始",
      "a6": "停止",
      "Importprivatekey": "导入刷单钱包私钥",
      "close": "关闭",
      "a7": "每行一个私钥",
      "import": "导入",
      "importwallet": "导入钱包",
      "a8": "1:请使用安全的浏览器操作",
      "a9": "2:每次操作完成后,点击导入刷单钱包按钮,删除私钥",
      "a10": "3:平台不会获取你的私钥,如果产生资金损失,平台概不负责",
      "a11": "市值机器人教学视频",
    }
  }

  return (
    <AppContext.Provider
      value={{
        setLanguage,
        Lang: chooseLanguage(Text)
      }}
    >
      {children}
    </AppContext.Provider>
  )
}